import './HighlightBox.scss';

import { PropsWithChildren } from 'react';

const classNames = 'c-HighlightBox';

type HighlightBoxProps = {
  backgroundColor?: string | null;
  borderColor?: string | null;
};

const HighlightBox = ({
  backgroundColor,
  borderColor,
  children,
}: PropsWithChildren<HighlightBoxProps>) => {
  return (
    <div
      className={classNames}
      style={{
        background: `var(${backgroundColor})`,
        borderColor: `var(${borderColor})`,
      }}
    >
      {children}
    </div>
  );
};

export default HighlightBox;
